/**
 * Delete
 */

import Config from '../Config';
import Util from '../Util';
import ParamInfo from './ParamInfo';
import Template from './Template';
import GameInfo from '../GameInfo';

class Delete {

	protected guid: string;

	protected paramInfo: any;

	protected articleId: string;

	protected _id: string;

	protected gameServerName: string;

	protected gameServerId: string;

	protected selector: string;

	constructor( guid: string, parentId: string = '', gameServerName: string = '', gameServerId: string = '' ) {
		this.guid = guid;
		this._id = parentId || `viewMoreList`;
		this.gameServerName = gameServerName;
		this.gameServerId = gameServerId;
		this.init();
	}

	public show() {
		jQuery( this.selector ).hide();

		if ( Config.guid && this.guid && ( Config.guid === this.guid ) ) {
			jQuery( this.selector ).show();
		}

		if ( this.gameServerName && this.gameServerId && GameInfo.isEqualGameUser( this.gameServerName, this.gameServerId ) ) {
			jQuery( this.selector ).show();
		}
	}

	protected addSelector() {
		// this.selector = `#${this._id} .co-btn-delete`;
		this.selector = `.${Config.COMMUNITY_NODE} .co-btn-delete`;
	}

	protected init() {
		this.addSelector();
		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();
		this.articleId = this.paramInfo.getParamByKey( 'articleId' );
		this.show();
		this.addEvent();
	}

	protected addEvent() {
		jQuery( 'body' ).on( 'click', this.selector, ( evt ) => {
			evt.preventDefault();

			Config.confirm( Config.L10N.alert_delete_article, () => {
				this.deleteArticle( ( bool: boolean ) => {
					if ( bool ) {
						if ( Config.isMobileSdk ) {
							location.href = Config.mobileSdk.articleDeleteCompleted();
						} else {
							location.href = Config.listPage + '?' + this.paramInfo.getParamIgnore( 'articleId' );
						}

						return;
					}

					Config.alert( Config.L10N.alert_retry );

				});
			}, () => {
				// error
			});
		});
	}

	protected deleteArticle( callback: any ) {
		const _post: any = Util.get( Config.delete({
			board: Config.board,
			articleId: this.articleId,
		}), 'DELETE' );
		const post$ = Util.from( _post );
		post$.subscribe( ( data: any ) => {
			if ( callback ) {
				callback( data );
			}
		}, ( data: any ) => {
			Config.apiError( data );
		});
	}
}

export default Delete;
